import dynamic from 'next/dynamic';

// Dynamically import Map component with SSR disabled
// Leaflet requires window object which doesn't exist during SSR
const Map = dynamic(() => import('./Map'), {
  ssr: false,
  loading: () => (
    <div
      className="bg-beige-100 animate-pulse rounded-[10px]"
      style={{ height: '400px', width: '100%' }}
    />
  ),
});

// Dynamically import marker components (they also use Leaflet)
export const ParkMarker = dynamic(() => import('./ParkMarker'), {
  ssr: false,
});

export const EventMarker = dynamic(() => import('./EventMarker'), {
  ssr: false,
});

export const StateBoundary = dynamic(() => import('./StateBoundary'), {
  ssr: false,
});

export const LocationMarker = dynamic(() => import('./LocationMarker'), {
  ssr: false,
});

export default Map;
